import { Avatar } from "@atoms/index"

import { UnknownAvatarProps } from "./UnknownAvatar.types"

export default function UnknownAvatar(props: UnknownAvatarProps) {
    return <Avatar isUnknown={true} {...props} />
}
